import { render, staticRenderFns } from "./boxRemark.vue?vue&type=template&id=42a05c8e&scoped=true&"
import script from "./boxRemark.vue?vue&type=script&lang=js&"
export * from "./boxRemark.vue?vue&type=script&lang=js&"
import style0 from "./boxRemark.vue?vue&type=style&index=0&id=42a05c8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a05c8e",
  null
  
)

export default component.exports